import { render, staticRenderFns } from "./KeyboardComponent.vue?vue&type=template&id=a7509a26&scoped=true&"
import script from "./KeyboardComponent.vue?vue&type=script&lang=js&"
export * from "./KeyboardComponent.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardComponent.vue?vue&type=style&index=0&id=a7509a26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7509a26",
  null
  
)

export default component.exports